module.exports = __webpack_public_path__ + "img/logo_printer_2.593e274f.png";